import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
const {sinkEvent} = commons;
import TablePanel from "../../components/TablePanel";
import CustomCheckbox from "../../components/CustomCheckbox";
import DopravceForm from "../../forms/DopravceForm";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Dopravci
 */
class DopravciPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchDopravciIfNeeded());
    };

    handleCreateDopravce = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            DopravceForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createDopravce(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateDopravci());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_carrier'),
            {size: "md"}
        ));
    };

    handleEditDopravce = (dopravce) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            DopravceForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateDopravce(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateDopravci());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: dopravce
            },
            t('carrier_change'),
            {size: "md"}
        ));
    };

    handleVcetneNeaktivnich = (e) => {
        const {dopravciList} = this.props;
        this.props.dispatch(ciselnikActions.filterDopravci({
            ...dopravciList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (dopravce) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditDopravce.bind(this, dopravce))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {dopravciList, t} = this.props;
        let content;
        if (dopravciList.fetched) {
            if (dopravciList.rows.length !== 0) {
                content = dopravciList.rows.map((dopravce) => {
                    return <CardBody key={dopravce.id} className={dopravce.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(dopravce)} onClick={this.handleEditDopravce.bind(this, dopravce)}>
                            <Row>
                                <Col xs={6}>{dopravce.dopravce}</Col>
                                <Col xs={2}>{dopravce.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_carriers')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = dopravciList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('admin.carriers')}
            subtitle={t('admin.system_operator_carriers')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateDopravce}>{t('new_m')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={6}>{t('dopravce')}</Col>
                            <Col xs={2}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        dopravciList: utils.storeFromArea(state, ciselnikActions.DOPRAVCI_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(DopravciPage));
